import type { TFunction } from "react-i18next"

import { CustomFormsSchemaFieldType, EmployerOfRecord } from "@oysterhr/schema"

export const contactsTabFields = (
  t: TFunction<"staff_interface/VendorsPage", string>,
  data?: EmployerOfRecord,
) => [
  {
    label: "generalEnquiriesEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "generalEnquiriesEmails",
        value: data?.details?.generalEnquiriesEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "generalEnquiriesNotes",
        value: data?.details?.generalEnquiriesNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "quoteRequestEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "quoteRequestEmails",
        value: data?.details?.quoteRequestEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "quoteRequestNotes",
        value: data?.details?.quoteRequestNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "escalationEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "escalationEmails",
        value: data?.details?.escalationEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "escalationNotes",
        value: data?.details?.escalationNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "payrollSpecialistRecipients",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "payrollSpecialistRecipients",
        value: data?.details?.payrollSpecialistRecipients?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "payrollSpecialistRecipientsNotes",
        value: data?.details?.payrollSpecialistRecipientsNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "newHiresOnboardingEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "newHiresOnboardingEmails",
        value: data?.details?.newHiresOnboardingEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "newHiresOnboardingNotes",
        value: data?.details?.newHiresOnboardingNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "supportEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "supportEmails",
        value: data?.details?.supportEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "supportNotes",
        value: data?.details?.supportNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "genericFinanceQuestionEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "genericFinanceQuestionEmails",
        value: data?.details?.genericFinanceQuestionEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "genericFinanceQuestionNotes",
        value: data?.details?.genericFinanceQuestionNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "expensesAndPayrollNotificationsEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "expensesAndPayrollNotificationsEmails",
        value: data?.details?.expensesAndPayrollNotificationsEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "expensesAndPayrollNotificationsNotes",
        value: data?.details?.expensesAndPayrollNotificationsNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "timeOffNotificationsEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "timeOffNotificationsEmails",
        value: data?.details?.timeOffNotificationsEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "timeOffNotificationsNotes",
        value: data?.details?.timeOffNotificationsNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
  {
    label: "timeOffMonthlyReportEmails",
    type: "emailFieldWithNotes",
    editModeType: "emailFieldWithNotes",
    value: [
      {
        label: "timeOffMonthlyReportEmails",
        value: data?.details?.timeOffMonthlyReportEmails?.map((email: string) => {
          return {
            email,
          }
        }),
        type: "email",
        editModeType: "email",
      },
      {
        label: "timeOffMonthlyReportNotes",
        value: data?.details?.timeOffMonthlyReportNotes,
        editModeType: CustomFormsSchemaFieldType.Text,
      },
    ],
  },
]
